/**
 * Extracts the bare uuid (last `:`-delimited segment) from a Vida urn, e.g.
 * `urn:vida:program:<uuid>` → `<uuid>`. Mirrors Sparta's `uuidFromUrn`, used to
 * turn the PHQ/GAD response's `qualifiedProgramUrns` into the `programUuid` that
 * `createProgramInstance` expects. Returns `undefined` for an empty/missing urn.
 */
export function uuidFromUrn(urn: string | undefined): string | undefined {
  if (!urn) return undefined;
  return urn.split(':').pop() || undefined;
}
